import {
    RECEIPT_LIST_REQUEST_SUCCESS,
    RECEIPT_LIST_REQUEST_FAIL 
} from "../action.types";
import initialValue from "../initial.state";

export default function (state = initialValue.receipts, action) {
    switch (action.type) {
        case RECEIPT_LIST_REQUEST_SUCCESS:
            return action.payload.values;
          case RECEIPT_LIST_REQUEST_FAIL:
            return state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/file/receipts.reducer.js